import {AttrsSchema, Component} from 'panel';

import * as Focusable from 'common/util/focusable';

export interface BaseButtonAttrs {
  disabled?: boolean;
  elref?: string;
  'not-focusable'?: boolean;
  href?: string;
  target?: string;
  readonly?: boolean;
  'style-override'?: string;
}

export const baseButtonParams = {
  disabled: Boolean,
  elref: String,
  'not-focusable': Boolean,
  href: String,
  target: String,
  readonly: Boolean,
  'style-override': String,
};

export class ButtonBase<AttrsT> extends Component<EmptyObj, BaseButtonAttrs & AttrsT> {
  static get attrsSchema(): AttrsSchema<BaseButtonAttrs> {
    return {
      ...super.attrsSchema,
      disabled: `boolean`,
      elref: `string`,
      'not-focusable': `boolean`,
      href: `string`,
      target: `string`,
      readonly: `boolean`,
    };
  }

  get config() {
    return {
      defaultState: {},
      template: () => null,
      useShadowDom: true,
      helpers: {
        getComponentClasses: (prefixFilter) => {
          const componentClasses = {};
          for (const className of Array.from(this.classList)) {
            if (className.startsWith(prefixFilter)) {
              componentClasses[className] = true;
            }
          }
          return componentClasses;
        },

        getButtonAttrs: () => {
          const attrs: BaseButtonAttrs = {disabled: false, 'not-focusable': false};
          if (this.attr(`disabled`)) {
            attrs.disabled = true;
          }
          if (this.attr(`readonly`)) {
            attrs[`readonly`] = true;
          }
          if (this.attr(`href`)) {
            attrs.href = this.attr(`href`);
          }
          if (this.attr(`target`)) {
            attrs.target = this.attr(`target`);
          }
          return attrs;
        },
      },
    };
  }

  get disabled() {
    return this.attr(`disabled`);
  }

  set disabled(disabled) {
    if (disabled) {
      this.setAttribute(`disabled`, ``);
    } else {
      this.removeAttribute(`disabled`);
    }
  }

  attributeChangedCallback(attr, oldValue, newValue) {
    super.attributeChangedCallback(attr, oldValue, newValue);
    Focusable.handleAttributeChangedCallback(this, attr);
  }

  connectedCallback() {
    super.connectedCallback();
    this.setAttribute(`role`, `button`);

    Focusable.handleConnectedCallback(this);
  }

  disconnectedCallback() {
    Focusable.handleDisconnectedCallback(this);
    super.disconnectedCallback();
  }
}
